module.exports = __webpack_public_path__ + "static/media/ODD.a1fd162d.png";